import React, { useState } from 'react';

interface AccordionItem { question: string; answer: string; }
interface AccordionProps { items: AccordionItem[]; }

const Accordion: React.FC<AccordionProps> = ({ items }) => {
  const [openIdx, setOpenIdx] = useState<number | null>(null);

  return (
    <div className="divide-y divide-grid-line border-y border-grid-line">
      {items.map((item, i) => {
        const isOpen = openIdx === i;
        const panelId = `accordion-panel-${i}`;
        const btnId = `accordion-btn-${i}`;
        return (
          <div key={i}>
            <button
              id={btnId}
              aria-expanded={isOpen}
              aria-controls={panelId}
              onClick={() => setOpenIdx(isOpen ? null : i)}
              className="w-full py-6 flex items-center justify-between text-left transition-colors"
            >
              <span className={`text-lg font-semibold transition-colors ${isOpen ? 'text-command-amber' : 'text-signal-white'}`}>
                {item.question}
              </span>
              <span className={`font-mono text-2xl transition-transform duration-200 ${isOpen ? 'rotate-45 text-command-amber' : 'text-steel'}`}>+</span>
            </button>
            <div
              id={panelId}
              role="region"
              aria-labelledby={btnId}
              hidden={!isOpen}
              className="pb-6 text-steel leading-relaxed measure"
            >
              {item.answer}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Accordion;
